const root = 'currentSubscriptionPlan'

export const TestId = {
  root,
  title: `${root}-title`,
  currentPlan: `${root}-currentPlan`,
}
